"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageBreadcrumbMixin = void 0;
var PageBreadcrumbMixin = function PageBreadcrumbMixin() {
  return "\n    display: flex;\n";
};
exports.PageBreadcrumbMixin = PageBreadcrumbMixin;